import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { getAvailablePhoneNumbers } from 'api/admin/businesses/twilioIntegration';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';
import { TwilioAvailablePhoneNumbersFilter, TwilioAvailablePhoneNumbersHttpResponse, TwilioAvailablePhoneNumbersRequestBody } from 'types/twilio/twilioAvailablePhoneNumber';

export const useGetTwilioAvailablePhoneNumbers = (
  businessId: number,
  filter: TwilioAvailablePhoneNumbersFilter,
) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    TwilioAvailablePhoneNumbersHttpResponse
  >({
    queryKey: [TwilioQueryKeys.AVAILABLE_PHONE_NUMBERS, businessId, filter],
    queryFn: async () => {
      const requestBody: TwilioAvailablePhoneNumbersRequestBody = {
        ...filter,
        areaCode: filter.areaCode ? Number(filter.areaCode) : undefined,
      }

      const response = await getAvailablePhoneNumbers({
        businessId,
        data: requestBody,
      });

      return response.data;
    },
    enabled: !!businessId,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching Twilio available phone numbers',
        {
          icon: '❌',
        },
      );
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
